const updateRoles = {
  toastr: 'Função atualizada',
  toastr1: ' foi atualizado com sucesso',
  toastrError: 'Função já cadastrada',
  toastrError1: 'Insira outro nome'
};

export default updateRoles;
